import { useSelector, useDispatch } from 'react-redux';
import NotificationModal from '../components/ui/NotificationModal';
import { uiActions } from '../store/ui-slice';

const RootUI = () => {
	const dispatch = useDispatch();
	const notificationState = useSelector(
		(state) => state.ui
	);
	const dismissNotificationHandler = () => {
		dispatch(uiActions.dismissNotification());
	};
	return (
		notificationState.activeNotification && (
			<NotificationModal
				title={notificationState.title}
				message={notificationState.message}
				onConfirm={dismissNotificationHandler}
				status={notificationState.status}
			/>
		)
	);
};
export default RootUI;
